export default __webpack_public_path__ + "static/media/TransportationCars_02.dae97a71.png";